export const environment = {
  emailAuthEnabled: false,
  debug: true,
  NODE_ENV: "development",
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyDEMq0KvAtYPtlun6B9NGr2XjYzQC1XTvM",
    authDomain: "ponderosametalworks.firebaseapp.com",
    databaseURL: "https://ponderosametalworks-default-rtdb.firebaseio.com",
    projectId: "ponderosametalworks",
    storageBucket: "ponderosametalworks.firebasestorage.app",
    messagingSenderId: "860120843567",
    appId: "1:860120843567:web:d60d740eb2295300bd0dda",
    measurementId: "G-7WF84Y262F"
  }
};
